import React from 'react'

import { InputProps } from '@/components/Form/Form.type'

import { inputStyles } from './Form.style'

const Input: React.FC<InputProps> = ({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  required,
  id,
  name,
  size = 'md',
  maxLength
}) => (
  <div className="mx-auto flex w-full flex-col">
    {label && (
      <label htmlFor={id} className="text-md mb-2 font-bold text-teal-800">
        {label}
      </label>
    )}
    <input
      type={type}
      id={id || name}
      name={name}
      value={value}
      required={required}
      onChange={onChange}
      placeholder={placeholder}
      maxLength={maxLength}
      className={inputStyles({ size })}
    />
  </div>
)

export default Input
